import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=ff1209a8&scoped=true&"
import script from "./ActivityForm.vue?vue&type=script&lang=js&"
export * from "./ActivityForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=ff1209a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1209a8",
  null
  
)

export default component.exports